/**
 * Feature flag — whether THIS website renders gamification (polls, quizzes,
 * predictors, leaderboards).
 *
 * Default **off**. Gamification entries are still authored in Contentful against
 * fixtures and articles so the native app can consume them, but they must NOT
 * render on the website unless this is explicitly enabled per deployment.
 *
 * Enable by setting `NEXT_PUBLIC_GAMIFICATION_ENABLED=true`. Anything else
 * (unset, `false`, …) disables all gamification rendering and skips mounting the
 * gamification provider.
 *
 * `NEXT_PUBLIC_` so the literal is inlined at build for the client-side
 * `RenderGamificationEntry` chokepoint as well as the server layout.
 */
export const isGamificationEnabled =
  process.env.NEXT_PUBLIC_GAMIFICATION_ENABLED === 'true';
